export enum AdminUserRoleEnum{
    consulting_healthUnit_alterar_usuario_master = 109,
    consulting_healthunit_visualizar_senha_temporaria = 110,
    consulting_healthunit_inserir = 15,
    consulting_healthunit_alterar = 16,
    
}